import invariant from 'tiny-invariant';
import { phpApiBase } from '../config';
import { store } from '../index';
import { PRICING_ERROR } from '../ducks/pricing';

export async function getPrice(
  numberOfPages,
  bookType = 'photo_books',
  forceReload = false,
) {
  try {
    const response = await getRequest(
      phpApiBase +
        `zoomUtils/prices?pages=${numberOfPages}&book_type=photo_books`,
    );
    return response;
  } catch (e) {
    console.error('error in getPrice', e);
    //only dispatch if we are not forcing a reload when pricing is already in an error state
    if (!forceReload) {
      store.dispatch({ type: PRICING_ERROR, payload: e.message });
    }
  }
}

export async function getProductOptions(productID) {
  invariant(typeof productID === 'number', `Invalid productID: ${productID}`);
  return await getRequest(
    phpApiBase + `userProject/productOptions?id=${productID}`,
  );
}

export async function renameProject(projectPK, name, author = null) {
  if (projectPK && name) {
    await getRequest(
      phpApiBase +
        `userProject/renameProject?projectPK=${projectPK}&name=${name}&author=${author}`,
    );
  }
}

export async function deleteProject(pk) {
  if (pk) {
    await postRequest(phpApiBase + `userProject/delete?id=${pk}`);
  }
}

export async function getUploadToken(projectPK) {
  return await getRequest(
    `${phpApiBase}auth/uploadToken?projectPK=${projectPK}`,
  );
}

export async function validateUploadToken(token) {
  return await getRequest(
    `${phpApiBase}auth/validateUploadToken?token=${token}`,
  );
}

// This is our token as returned from getToken service
// var token = undefined;
export async function getToken() {
  const response = await postRequest(phpApiBase + 'zoomUtils/getToken');
  return response;
}

export async function tradeToken(token) {
  await getRequest(`${phpApiBase}auth/redirect?token=${token}`);
}

export async function getMarketingBanner() {
  return await getRequest(phpApiBase + `zoomUtils/marketingBanner`);
}

export async function getRequest(url, projectPK, propertyName, mode) {
  let config = {
    credentials: 'include',
    method: 'GET',
  };

  if (mode) {
    config = { ...config, mode };
  }

  try {
    const response = await fetch(url, config);
    if (response.ok) {
      try {
        let responseObject = await response.json();
        if (propertyName && responseObject[propertyName]) {
          return responseObject[propertyName];
        } else {
          return responseObject;
        }
      } catch (e) {}
    } else {
      console.warn('result code', response.status);
      throw new Error('Bad response', response);
    }
  } catch (e) {
    console.error('getRequest', e);
    throw e;
  }
  return null;
}

async function postRequest(url, params, propertyName) {
  try {
    const response = await fetch(url, {
      credentials: 'include',
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },

      body: JSON.stringify(params),
    });

    let responseObject = await response.json();
    if (propertyName && responseObject[propertyName]) {
      return responseObject[propertyName];
    } else {
      return responseObject;
    }
  } catch (e) {
    console.log({ url }, e);
    console.error(e);
    throw e;
  }
  return null;
}
